import { useAtomValue } from 'jotai';

import { Divider, SkeletonRect, Stack, Text } from '@ekhodealer/ekho-common/rev';

import { EmptySection } from '@common/components/EmptySection';

import { useGetOrderTimeline } from '../../api/useGetOrderTimeline';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';

import { NoteForm } from './NoteForm';
import { TimelineNoteItem } from './TimelineNoteItem';

/**
 * TimelineTabContent component
 * Main component for the Timeline tab showing order notes
 */
export const TimelineTabContent = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: timeline, isLoading } = useGetOrderTimeline(selectedRow?.purchasedVehicleId);

	const notes = timeline?.notes || [];
	const hasNotes = notes.length > 0;

	return (
		<Stack itemsSpacing='24' padding={{ top: '12' }}>
			{/* Notes list */}
			{isLoading ? (
				<Stack itemsSpacing='16'>
					<SkeletonRect width='100%' height={80} />
				</Stack>
			) : hasNotes ? (
				<Stack itemsSpacing='16'>
					<Text size='heading' weight='semibold'>
						Notes ({notes.length})
					</Text>
					<Stack itemsSpacing='12'>
						{notes.map((note) => (
							<TimelineNoteItem key={note.id} note={note} />
						))}
					</Stack>
				</Stack>
			) : (
				<Stack itemsSpacing='8'>
					<EmptySection message='No notes for this order yet' />
				</Stack>
			)}

			<Divider />

			{/* Note creation form */}
			<Stack itemsSpacing='12'>
				<Text size='body' weight='semibold'>
					Add a note
				</Text>
				{isLoading ? <SkeletonRect width='100%' height={80} /> : <NoteForm />}
			</Stack>
		</Stack>
	);
};
